module.exports = __webpack_public_path__ + "img/团队名.9f2ea92e.svg";